export default "__VITE_ASSET__BhbSs_v4__"